import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/** 契約情報 */
export type kei01p = {
  /** 証券番号 */
  tf_kekeno: string;
  /** ポリシー */
  tf_keplcy: string;
  /** 更新回数 */
  tf_keksct: string;
  /** 保険商品コード */
  tf_kehscd: string;
  /** 保険プラン */
  tf_kehkpl: string;
  /** 保険料 */
  tf_kegkhk: number;
  /** 内容把握確認 */
  tf_kehaak: string;
  /** 重要事項説明 */
  tf_kejyjk: string;
  /** 意向確認 */
  tf_keikkn: string;
  /** 申込経路 */
  tf_kemskr: string;
  /** 申込日 */
  tf_kemsdt: string;
  /** 責任開始日 */
  tf_kessdt: string;
  /** 始期日 */
  tf_keskdt: string;
  /** 満期日 */
  tf_kemkdt: string;
  /** 異動日 */
  tf_keiddt: string;
  /** 契約者名漢字 */
  tf_kekykj: string;
  /** 契約者名カナ */
  tf_kekykn: string;
  /** 契約者郵便番号 */
  tf_kekyyn: string;
  /** 契約者住所1 */
  tf_kekya1: string;
  /** 契約者住所2 */
  tf_kekya2: string;
  /** 契約者住所3 */
  tf_kekya3: string;
  /** 契約者電話番号 */
  tf_kekytl: string;
  /** 契約者電話番号（携帯） */
  tf_kekyt2: string;
  /** 契約者メールアドレス */
  tf_kekyma: string;
  /** 他保険有無 */
  tf_kethum: string;
  /** 他保険会社名 */
  tf_kethcm: string;
  /** 他保険保険金額 */
  tf_kethkg: number;
  /** 払込方法 */
  tf_kehkhh: string;
  /** 払込回数 */
  tf_kehkks: string;
  /** 代理店コード */
  tf_kedrcd: string;
  /** 支店コード */
  tf_kestcd: string;
  /** 募集人コード */
  tf_kebscd: string;
  /** 異動事由 */
  tf_keidjy: string;
  /** 保険料領収日 */
  tf_keybd1: string;
  /** 変更日時 */
  tf_kehkdt: number;
};

/** 料率情報 */
export type hsm03p = {
  /** 商品名称 */
  tf_hrshnm: string;
  /** 補償名称 */
  tf_hrplnm: string;
  /** 家財保険料 */
  tf_hrhrhk: number;
  /** 付帯保険料 */
  tf_hrhthk: number;
  /** 家財保険金額（万円） */
  tf_hrhkkg: number;
  /** 付帯保険金額（万円） */
  tf_hrhtkg: number;
  /** 証券発行フラグ */
  tf_hrsknf: string;
};

/** 被保険者情報 */
export type kei02p = {
  /** 被保険者番号 */
  tf_khhkno: string;
  /** 所有区分 */
  tf_khsykb: string;
  /** 用途 */
  tf_khytkb: string;
  /** 構造 */
  tf_khkozo: string;
  /** 契約者と同じ */
  tf_khkysm: string;
  /** 被保険者カナ */
  tf_khhksk: string;
  /** 被保険者漢字 */
  tf_khhksj: string;
  /** 被保険者性別 */
  tf_khhksx: string;
  /** 被保険者生年月日 */
  tf_khhkbt: string;
  /** 被保険者住所郵便番号 */
  tf_khhkyn: string;
  /** 被保険者住所1 */
  tf_khhka1: string;
  /** 被保険者住所2 */
  tf_khhka2: string;
  /** 被保険者住所3 */
  tf_khhka3: string;
  /** 被保険者電話番号 */
  tf_khhktl: string;
  /** 被保険者電話番号（携帯電話） */
  tf_khhkt2: string;
  /** 被保険者メールアドレス */
  tf_khhkma: string;
  /** 変更日時 */
  tf_khhkdt: number;
};

/**
 * API0430 契約情報取得 レスポンスインターフェース
 */
export type contractResponse = {
  kei01p?: kei01p;
  hsm03p?: hsm03p;
  kei02p?: kei02p[];
};

/**
 * API0430 契約情報取得
 * @returns
 */
export const getContract = async (): Promise<AxiosResponse<contractResponse>> => {
  return await authRequest.get("/v1/user/contracts");
};
